import { useAppNavigate } from '@shared/store';
import dayjs from 'dayjs';
import { getRowsWithHeaders, OpenVisitsType } from '../../entity';
import { useVisitsQuery } from '../../queries';
import { createVisitsColumns } from './columns';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

export const useVisitsListOpen = (): OpenVisitsType => {
  const navigate = useAppNavigate();
  const { t } = useIntlTranslations();

  const { data: visits, isLoading } = useVisitsQuery({});

  if (isLoading || !visits) {
    return { rows: [], columns: [], isLoading, visits: [] };
  }

  const openVisits = visits.filter(
    ({ visit }) => !visit.visitStatus && dayjs(visit.dateFrom).isBefore(dayjs()),
  );
  const sortedVisits = [...openVisits].sort(
    (a, b) => dayjs(a.visit.dateFrom).valueOf() - dayjs(b.visit.dateFrom).valueOf(),
  );
  const rows = getRowsWithHeaders(sortedVisits, t);
  const columns = createVisitsColumns(navigate);

  return { rows, columns, isLoading, visits };
};
